// @flow
import * as React from 'react';

import { Container, Row, Col } from 'reactstrap';
import Truncate from 'react-truncate';

// Components
import { Icon } from 'components/atoms/Icon/';

// Utils
import {
  RECALL_SERVICES_ROUTE,
  RECALL_VIN_SEARCH_ROUTE
} from 'constants/routes';
import { NAVIGATION } from 'constants/navigations';
import { isTrue, undefinedToTrue } from 'utils/varValidation';

// Constants
import { APP_FLOW } from 'constants/appFlow';

import './RecallOptions.scss';

const { FORWARD } = NAVIGATION;

type Props = {
  recallServices: Array<Object>,
  configMake: Object,
  goTo: (path: string, direction: string) => void,
  policies: Object,
  appFlow: string,
  intl: Object
};

class RecallOptions extends React.Component<Props> {
  static block = 'recall-options';

  drawOption = (label: string, count: number, routePath: string) => {
    const { goTo, intl } = this.props;
    const ns = RecallOptions.block;
    return (
      <div className={ns} onClick={() => goTo(routePath, FORWARD)}>
        <Container
          onKeyUp={event => {
            if (event.key === 'Enter') {
              goTo(routePath, FORWARD);
            }
          }}
          tabIndex={0}
          aria-label={intl.formatMessage({
            id: 'c8.search.for.recalls.on.this.vehicle',
            defaultMessage: 'Search for recalls on this vehicle'
          })}
        >
          <Row className={`${ns}__row`}>
            <Col>
              <div className={`${ns}--right`}>
                <Icon type="chevron__right" />
              </div>
              <Truncate className={`${ns}__option`} lines={1} ellipsis="…">
                <span>{label}</span>
              </Truncate>
              {count > 0 && <div className={`${ns}__count`}>{count}</div>}
            </Col>
          </Row>
        </Container>
      </div>
    );
  };

  render() {
    const { recallServices, policies, configMake, appFlow, intl } = this.props;
    const count = recallServices ? recallServices.length : 0;
    const availableSearch =
      isTrue(undefinedToTrue(policies.mfgCampaignOn)) &&
      configMake.recallControl === 'BOOKABLE';
    if (count > 0) {
      return this.drawOption(
        intl.formatMessage({
          id: 'c8.services.page.recalls.button.active'
        }),
        count,
        RECALL_SERVICES_ROUTE
      );
    }
    if (availableSearch && appFlow === APP_FLOW.IM_NEW_HERE) {
      return this.drawOption(
        intl.formatMessage({
          id: 'c8.services.page.recalls.button.search'
        }),
        0,
        RECALL_VIN_SEARCH_ROUTE
      );
    }

    return null;
  }
}

export default RecallOptions;



// WEBPACK FOOTER //
// ./src/components/molecules/RecallOptions/RecallOptions.js